import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownFoldMenu } from 'components/Dropdown/menus/Fold/DropdownFoldMenu';

import { PostOnIdealistDropdownSearchItemData } from './data/PostOnIdealistDropdownData';
import { postOnIdealistDropdownDataByLocale } from './data/postOnIdealistDropdownDataByLocale';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
};

const dataBySearchItemType: Record<
  PostOnIdealistDropdownSearchItemData['type'],
  { qaId: string; trackClickedName: string }
> = {
  'post-a-listing': {
    qaId: 'nav-post-a-listing-link',
    trackClickedName: 'Post on Idealist Header Dropdown > Post A Listing',
  },
  'create-org': {
    qaId: 'nav-create-org-link',
    trackClickedName: 'Post on Idealist Header Dropdown > Create Org',
  },
  'create-community-group': {
    qaId: 'nav-create-community-group-link',
    trackClickedName:
      'Post on Idealist Header Dropdown > Create Community Group',
  },
};

export function PostOnIdealistDropdown({ locale, renderTrigger }: Props) {
  const { triggerText, triggerHref, search, resources } =
    postOnIdealistDropdownDataByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText, triggerHref })}
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: search.title,
          items: search.items.map((searchItem) => ({
            icon: undefined,
            title: searchItem.title,
            href: searchItem.href,
            qaId: dataBySearchItemType[searchItem.type].qaId,
            trackClickedName:
              dataBySearchItemType[searchItem.type].trackClickedName,
          })),
        }}
        right={{
          title: resources.title,
          items: resources.items.map((resourceItem) => ({
            image: resourceItem.image,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
          })),
        }}
      />
    </Dropdown>
  );
}
